import { ButtonModule } from '@challenger6/vm-pattern-library/button';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { ModalModule } from '@challenger6/vm-pattern-library/modal';
import { NgModule } from '@angular/core';
import { TrySomethingElseComponent } from './try-something-else.component';
import { ModalWithLinkModule } from '../modal-with-link/modal-with-link.module';
import { LiveChatV3Module } from './../../directives/live-chat-v3/live-chat-v3.module';

@NgModule({
  declarations: [TrySomethingElseComponent],
  imports: [CommonModule, ButtonModule, ModalModule, MarkdownModule.forChild(), ModalWithLinkModule, LiveChatV3Module],
  exports: [TrySomethingElseComponent],
})
export class TrySomethingElseModule {}
